//REGULAR EXPRESSIONS
//Mobile Regex
export const MOBILE_REGEX = (value) => {
  const regex = /^[0-9\b]+$/;
  if (value.length <= 10) return value === "" || regex.test(value);
};

//AADHAR Regex
export const AADHAR_REGEX = (value) => {
  const regex = /^[0-9\b]+$/;
  if (value.length <= 12) return value === "" || regex.test(value);
};

//Name Regex
export const NAME_REGEX = (value, max = 60) => {
  // Disallow emojis and non-ASCII symbols explicitly
  const regex = new RegExp(
    `^(?!.*[^\\x00-\\x7F])(?!\\s)(?!.*\\s{2})[A-Za-z.][A-Za-z.\\s]{0,${max}}$`
  );

  if (value.length <= max) {
    return value === "" || regex.test(value);
  }
  return false;
};
//Remarks Regex
export const FREE_TEXT_REGEX = (value) => {
  const regex = /^[a-zA-Z0-9 \s!@#$%^&*()_+={}[\]:;,.?~\\/-\s]*$/;
  return value === "" || regex.test(value);
};

export const FREE_MAILING_ADDRESS_REGEX = (value) => {
  if (value === "") return true;
  if (value.trim() === "") return false;
  // Return the value if it matches, else return empty string
  let trimmedValue =
    value.match(/^(?!\s)(?!.*\s{2})[A-Za-z0-9,.–:/ -]+$/)?.[0] || "";
  return trimmedValue;
};

export const FREE_WORK_ADDRESS_REGEX = (value) => {
  if (value === "") return true;
  if (value.trim() === "") return false;
  // Return the value if it matches, else return empty string
  // let trimmedValue = value.match(/^[A-Za-z0-9,.–:/ -]+$/)?.[0] || "";
  let trimmedValue =
    value.match(/^(?!\s)(?!.*\s{2})[A-Za-z0-9,.–:/ -]+$/)?.[0] || "";
  return trimmedValue;
};
//Password Regex
export const PASSWORD_REGEX = (value) => {
  const passwordRegex = /^[a-zA-Z0-9\s!@#$%^&*()_+={}[\]:;,.?~\\/-]+$/;
  return value === "" || passwordRegex.test(value);
};

//Number Regex
export const NUMBER_REGEX = (value) => {
  const regex = /^[0-9\b]+$/;
  return value === "" || regex.test(value);
};
//UPI ID
export const UPI_ID_REGEX = (value) => {
  const regex = /^[a-zA-Z0-9.\-_]@[a-zA-Z]$/;
  return value === "" || regex.test(value);
};

// export const COMPANY_NAME_REGEX = (value) => {
//   const regex = /^[a-zA-Z0-9-_. ]*$/;
//   return value === "" || regex.test(value);
// };
export const COMPANY_NAME_REGEX = (value) => {
  const regex = /^[a-zA-Z][a-zA-Z0-9-_. \b]{0,80}$/;
  if (value.length <= 80) return value === "" || regex.test(value);
};
export const ACCOUNT_NO_REGEX = /^[0-9\- ]{6,20}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
